module.exports = function (c) {
  function d(g, h, j, k) {
    this.x = g;
    this.y = h;
    this.width = j;
    this.height = k;
    this.finalX = g + j;
    this.finalY = h + k;
  }
  d.prototype.set = function (g, h, j, k, l, m) {
    this.x = g;
    this.y = h;
    this.finalX = j;
    this.finalY = k;
    this.width = l;
    this.height = m;
    return this;
  };
  d.prototype.fits = function (g) {
    var h = g.image.width;
    var j = g.image.height;
    return !!(h <= this.width) && !!(j <= this.height);
  };
  d.prototype.fitsPerfectly = function (g) {
    var h = g.image.width;
    var j = g.image.height;
    return h == this.width && j == this.height;
  };
  d.prototype.overlaps = function (g) {
    return (
      this.x < g.x + g.width &&
      this.x + this.width > g.x &&
      this.y < g.y + g.height &&
      this.y + this.height > g.y
    );
  };
  function f(j) {
    this.MAX_TEXTURE_SIZE = 4096;
    if (j) {
      this.dataURLs = {};
      for (var k in j) {
        var q = j[k];
        if (q instanceof c.CompressedTexture) {
          throw new Error("CompressedTextures are not supported.");
        }
        if (q.image.toDataURL === undefined) {
          var v = document.createElement("canvas");
          v.width = q.image.naturalWidth;
          v.height = q.image.naturalHeight;
          v.getContext("2d").drawImage(q.image, 0, 0);
          this.dataURLs[k] = v.toDataURL();
        } else {
          this.dataURLs[k] = q.image.toDataURL();
        }
      }
      this.canvas = document.createElement("canvas");
      this.textureCount = 0;
      this.maxWidth = 0;
      this.maxHeight = 0;
      var w = "";
      for (k in j) {
        this.textureCount++;
        (z = j[k]).area = z.image.width * z.image.height;
        if (z.image.width > this.maxWidth) {
          this.maxWidth = z.image.width;
        }
        if (z.image.height > this.maxHeight) {
          this.maxHeight = z.image.height;
        }
        w += k + ",";
      }
      w = w.substring(0, w.length - 1);
      this.textureCache = {};
      this.node = {};
      this.node.rectangle = new d(
        0,
        0,
        this.maxWidth * this.textureCount,
        this.maxHeight * this.textureCount,
      );
      this.textureOffsets = {};
      this.allNodes = [];
      this.insert(this.node, this.findNextTexture(j), j);
      this.ranges = {};
      var x = this.calculateImageSize(j);
      this.canvas.width = x.width;
      this.canvas.height = x.height;
      var y = this.canvas.getContext("2d");
      this.context = y;
      for (k in this.textureOffsets) {
        var z = j[k];
        var A = this.textureOffsets[k].x;
        for (
          var B = this.textureOffsets[k].y,
            C = z.image.width,
            D = z.image.height,
            E = B;
          E < B + D;
          E += D
        ) {
          for (var F = A; F < A + C; F += C) {
            y.drawImage(z.image, F, E, C, D);
          }
        }
        var G = {
          startU: A / x.width,
          endU: (A + C) / x.width,
          startV: 1 - B / x.height,
          endV: 1 - (B + D) / x.height,
          width: C,
        };
        this.ranges[k] = G;
      }
      this.makeCanvasPowerOfTwo();
      this.mergedTexture = new c.CanvasTexture(this.canvas);
      this.mergedTexture.wrapS = c.ClampToEdgeWrapping;
      this.mergedTexture.wrapT = c.ClampToEdgeWrapping;
      this.mergedTexture.minFilter = c.NearestFilter;
      this.mergedTexture.magFilter = c.NearestFilter;
      this.mergedTexture.needsUpdate = true;
    }
  }
  f.prototype.isTextureAlreadyInserted = function (g, h) {
    var j = h[g];
    var k = this.dataURLs[g];
    for (var l in h) {
      if (l != g) {
        var m = h[l];
        if (
          k == this.dataURLs[l] &&
          m.offset.x == j.offset.x &&
          m.offset.y == j.offset.y &&
          m.offset.z == j.offset.z &&
          m.repeat.x == j.repeat.x &&
          m.repeat.y == j.repeat.y &&
          m.flipX == j.flipX &&
          m.flipY == j.flipY &&
          m.wrapS == j.wrapS &&
          m.wrapT == j.wrapT &&
          this.textureOffsets[l]
        ) {
          return this.textureOffsets[l];
        }
      }
    }
    return false;
  };
  f.prototype.insert = function (j, q, z) {
    var B = z[q];
    var D = this.isTextureAlreadyInserted(q, z);
    if (D) {
      this.textureOffsets[q] = D;
      if ((aa = this.findNextTexture(z)) != null) {
        this.insert(j, aa, z);
      }
      return;
    }
    var F = B.image.width;
    var G = B.image.height;
    if (j.upperNode) {
      var H;
      var J =
        this.maxWidth * this.textureCount + this.maxHeight * this.textureCount;
      var K = 0;
      var L = false;
      for (var N = 0; N < this.allNodes.length; N++) {
        if (!(H = this.allNodes[N]).textureName && H.rectangle.fits(B)) {
          this.textureOffsets[q] = {
            x: H.rectangle.x,
            y: H.rectangle.y,
          };
          var P = this.calculateImageSize(z);
          var Q = P.width + P.height;
          if (
            Q < J &&
            P.width <= this.MAX_TEXTURE_SIZE &&
            P.height <= this.MAX_TEXTURE_SIZE
          ) {
            var U = false;
            for (var V in this.textureOffsets) {
              if (V != q) {
                var W = H.rectangle;
                var X = this.textureOffsets[V].x;
                var Y = this.textureOffsets[V].y;
                var Z = z[V].image;
                var a0 = new d(W.x, W.y, F, G);
                var a1 = new d(X, Y, Z.width, Z.height);
                if (a0.overlaps(a1)) {
                  U = true;
                }
              }
            }
            if (!U) {
              J = Q;
              K = this.allNodes[N];
              L = true;
            }
          }
          delete this.textureOffsets[q];
        }
      }
      if (!L) {
        throw new Error("Error: Try to use smaller textures.");
      }
      this.textureOffsets[q] = {
        x: K.rectangle.x,
        y: K.rectangle.y,
      };
      K.textureName = q;
      if (!K.children) {
        var a2 = {};
        (a9 = {}).upperNode = K;
        a2.upperNode = K;
        K.children = [a9, a2];
        var a3 = K.rectangle.x;
        var a4 = K.rectangle.y;
        var a5 = this.maxWidth * this.textureCount;
        var a6 = this.maxHeight * this.textureCount;
        a9.rectangle = new d(a3 + F, a4, a5 - (a3 + F), a6 - a4);
        a2.rectangle = new d(a3, a4 + G, a5 - a3, a6 - (a4 + G));
        this.allNodes.push(a9);
        this.allNodes.push(a2);
      }
      if ((aa = this.findNextTexture(z)) != null) {
        this.insert(j, aa, z);
      }
    } else {
      var a7 = j.rectangle.width;
      var a8 = j.rectangle.height;
      j.textureName = q;
      var a9;
      a2 = {};
      (a9 = {}).upperNode = j;
      a2.upperNode = j;
      j.children = [a9, a2];
      a9.rectangle = new d(F, 0, a7 - F, G);
      a2.rectangle = new d(0, G, a7, a8 - G);
      this.textureOffsets[q] = {
        x: j.rectangle.x,
        y: j.rectangle.y,
      };
      var aa;
      var ab = j.children[0];
      this.allNodes = [j, a9, a2];
      if ((aa = this.findNextTexture(z)) != null) {
        this.insert(ab, aa, z);
      }
    }
  };
  f.prototype.makeCanvasPowerOfTwo = function (g) {
    var h = false;
    if (!g) {
      g = this.canvas;
      h = true;
    }
    var j = g.width;
    var k = g.height;
    var l = Math.pow(2, Math.round(Math.log(j) / Math.log(2)));
    var m = Math.pow(2, Math.round(Math.log(k) / Math.log(2)));
    var o = document.createElement("canvas");
    o.width = l;
    o.height = m;
    o.getContext("2d").drawImage(g, 0, 0, l, m);
    if (h) {
      this.canvas = o;
    }
  };
  f.prototype.calculateImageSize = function (g) {
    var h = 0;
    var j = 0;
    for (var k in this.textureOffsets) {
      var m = g[k];
      var p = m.image.width;
      var q = m.image.height;
      var u = this.textureOffsets[k].x;
      var v = this.textureOffsets[k].y;
      if (u + p > h) {
        h = u + p;
      }
      if (v + q > j) {
        j = v + q;
      }
    }
    return {
      width: h,
      height: j,
    };
  };
  f.prototype.findNextTexture = function (g) {
    var h;
    var j = -1;
    for (textureName in g) {
      var k = g[textureName];
      if (!this.textureCache[textureName] && k.area > j) {
        j = k.area;
        h = textureName;
      }
    }
    if (j == -1) {
      return null;
    } else {
      this.textureCache[h] = true;
      return h;
    }
  };
  f.prototype.rescale = function (g, h) {
    var j = document.createElement("canvas");
    j.width = g.width * h;
    j.height = g.height * h;
    j.getContext("2d").drawImage(
      g,
      0,
      0,
      g.width,
      g.height,
      0,
      0,
      j.width,
      j.height,
    );
    return j;
  };
  return f;
};
